import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_EVENT_SUCCESS,
  FETCH_EVENT_STATUS_END,
  FETCH_EVENT_STATUS_START,
  FETCH_EVENT_STATUS_SUCCESS,
  FETCH_EVENT_SUCCESS,
  FETCH_FILTER_FOR_MODULE_SUCCESS,
  GET_EVENT_SUCCESS,
  SAVE_EVENT_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_EVENT_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_EVENT_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_EVENT_SUCCESS,
    data
  };
};

export const fetchFilterModuleSuccess = (data) => {
  return {
    type: FETCH_FILTER_FOR_MODULE_SUCCESS,
    data
  }
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_EVENT_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {event} = store.getState();
      const {query} = event;
      const response = await axios.get(`/event?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {event} = store.getState();
      const {query} = event;
      const response = await axios.get(`/event/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      let formData = new FormData();
      Object.keys(payload).forEach(key => {
        if(key === 'emailDocuments' || key === 'slackDocuments') {
          return
        }
        formData.append(key, payload[key]);
      });
      const response = await axios.post(`/event`, formData);
      dispatch(fetchSuccess());
      if(response && response.data && response.data.code) {
        return message.error(response.data.message);
      }
      dispatch(createResourceSuccess({data: response.data}));
      if(!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/event');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const fetchFiltersForModule = (module) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/schema?model=${module}`);
      if(module === 'JobCard') {
      }
      dispatch(fetchSuccess());
      if(response && response.data && module === 'Asset') {
        response.data['invoiceDate'] = {
          field: "invoiceDate",
          options: {required: false, disabledOnEdit: true, hidden: true},
          required: false,
          type: "Date",
        }
        response.data['invoiceValue'] = {
          field: "invoiceValue",
          options: {required: false, disabledOnEdit: true, hidden: true},
          required: false,
          type: "Number",
        }
      }
      dispatch(fetchFilterModuleSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();
      // const emailDocuments = [];
      // const emailDocumentsIds = [];
      // payload.emailDocuments && payload.emailDocuments.map((item, index) => {
      //   if (!item.file.path) {
      //     formData.append('files', item.file);
      //     let data = {...item};
      //     delete data.file;
      //     emailDocuments.push(data);
      //   } else {
      //     emailDocumentsIds.push(item._id);
      //   }
      // });
      //
      // formData.append('emailDocuments', JSON.stringify(emailDocuments));
      // formData.append('emailDocumentsIds', JSON.stringify(emailDocumentsIds));
      //
      // const slackDocuments = [];
      // const slackDocumentsIds = [];
      // payload.slackDocuments && payload.slackDocuments.map((item, index) => {
      //   if (!item.file.path) {
      //     formData.append('files', item.file);
      //     let data = {...item};
      //     delete data.file;
      //     slackDocuments.push(data);
      //   } else {
      //     slackDocumentsIds.push(item._id);
      //   }
      // });
      //
      // formData.append('slackDocuments', JSON.stringify(slackDocuments));
      // formData.append('slackDocumentsIds', JSON.stringify(slackDocumentsIds));

      Object.keys(payload).forEach(key => {
        if(key === 'emailDocuments' || key === 'slackDocuments') {
          return
        }
        formData.append(key, payload[key]);
      });

      await axios.put(`/event/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(getResource());
      history.push('/event');
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    try {
      const response = await axios.get(`/event/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/event/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const eventStatus = (code) => {
  return async (dispatch) => {
    dispatch(fetchStatusStart());
    try {
      const response = await axios.get(`/event/event-status/${code}`);
      dispatch(fetchStatusEnd());
      dispatch(fetchStatusSuccess({data: response.data}));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchStatusSuccess = ({data}) => {
  return {
    type: FETCH_EVENT_STATUS_SUCCESS,
    data
  };
};

export const fetchStatusStart = () => {
  return {
    type: FETCH_EVENT_STATUS_START,
  };
};


export const fetchStatusEnd = () => {
  return {
    type: FETCH_EVENT_STATUS_END,
  };
};


export const eventStatusChange = (id, code, toStart) => {
  // console.log(id, code, toStart)
  return async (dispatch) => {
    dispatch(fetchStatusStart());
    try {
      const response = await axios.get(`/event/event-status-change/${id}/${toStart}`);
      dispatch(fetchStatusEnd());
      // dispatch(fetchStatusSuccess({data: response.data}));
      dispatch(eventStatus(code));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};



